import { FC, useContext, useEffect, useState } from "react";
import { Button, Col, InputGroup, Modal, Row, Stack } from "react-bootstrap";
import * as Yup from "yup";
import { AppContext } from "../../../appContext/AppContext";
import { Formik, FormikHelpers } from "formik";
import { VatTu, initialValuesThemMoiVatTu } from "./models/ThemMoiVatTuModel";
import { useIntl } from "react-intl";
import FormThemMoi from "./components/FormThemMoi";
import "./ThemMoiVatTu.scss";
import { addVatTu, updateVatTu } from "../../services/ThongKeServices";
import { CODE } from "../../../utils/Constant";
import { toast } from "react-toastify";
import { PhanHeThongKeContextProps, PhanHeThongKeContext } from "../../PhanHeThongKe"
import { generateForm, generateInitValues, generateValidationSchema } from "../../../utils/AppFunction";
import BackButton from "../../../component/BackButton";
import ModelHeader from "../../../component/ModelHeader";
import {handleThrowResponseMessage} from "../../../component/generate-form/GenerateFormConfig";
import {log} from "node:util";

type Props = {
  show: boolean;
  onHide: () => void;
};


const DialogThemMoiVatTu: FC<Props> = (props) => {
  const { show, onHide } = props;
  const intl = useIntl();
  const { setIsLoading } = useContext(AppContext);
  const { dataVatTuEdit, nhomVatTu } = useContext<PhanHeThongKeContextProps>(PhanHeThongKeContext);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [initialValuesVatTu, setInitialValuesVatTu] = useState<any>({
    [nhomVatTu?.description || 'thongTinChung']: {
      ROA: "",
      code: "",
      materialType: "",
      name: "",
      unitofMeasure: "",
      bloodGroup: "",
    }
  });

  useEffect(() => {
    if (nhomVatTu?.id) {
      getListform();
    }
  }, [dataVatTuEdit])

  const getListform = async () => {
    let data = await generateForm(`${nhomVatTu?.description}`, setIsLoading)
    setListJsonGenerate(data);
    setInitialValuesVatTu(
      // generateInitValues(data, nhomVatTu?.description || 'thongTinChung'))
      {
        ...initialValuesVatTu,
        [nhomVatTu?.description || 'thongTinChung']: {
          ...generateInitValues(listJsonGenerate, nhomVatTu?.description || 'thongTinChung')?.thongTinChung,
          ...initialValuesVatTu?.[nhomVatTu?.description || 'thongTinChung'],
          ...dataVatTuEdit?.[nhomVatTu?.description],
          medicinePicture: [{src: dataVatTuEdit?.[nhomVatTu?.description]?.medicinePicture ?? dataVatTuEdit?.['thongTinChung']?.medicinePicture}],
        }
      }
    )

  }
  // useEffect(() => {
  //   setInitialValuesVatTu({
  //     ...dataVatTuEdit,
  //     [nhomVatTu?.description || 'thongTinChung']: {
  //       ...initialValuesVatTu?.[nhomVatTu?.description || 'thongTinChung'],
  //       ...dataVatTuEdit?.[nhomVatTu?.description],
  //     }
  //   })
  //   // setInitialValuesVatTu({
  //   //   ...dataVatTuEdit,
  //   //   thongTinChung: {
  //   //     ...generateInitValues(listJsonGenerate, nhomVatTu?.description  || 'thongTinChung')?.thongTinChung,
  //   //     ...dataVatTuEdit?.thongTinChung
  //   //   }
  //   // })
  // }, [dataVatTuEdit])
  // Key của body phải trùng modelID trên URL (term_class.description),
  // không suy ra từ term_class.id vì id có thể khác nhau giữa các viện.
  const handlerConvertValues = (data: any, modelID: string) => {
    return {
      id: data?.id || dataVatTuEdit?.id,
      [modelID]: {
        ...data?.[modelID],
        medicinePicture: data?.[modelID]?.medicinePicture?.[0]?.src,
        materialGroup: nhomVatTu?.id
      },
    }
  }
  const handleFormSubmit = async (values: any) => {
    if (!nhomVatTu?.id) {
      toast.warning("Vui lòng chọn nhóm vật tư");
      return;
    }
    const modelID = nhomVatTu?.description || "thongTinChung";
    let dataValues = handlerConvertValues(values, modelID);
    try {
      setIsLoading(true);
      let { data } = (dataValues?.id || dataVatTuEdit?.id)
        ? await updateVatTu({
          lstModelType: dataValues,
        })
        : await addVatTu({
          lstModelType: dataValues
        }, modelID);
      if (CODE.SUCCESS === data?.code) {
        toast.success(((dataValues?.id) ? "Cập nhật" : "Thêm") + ` ${nhomVatTu?.defauiltName} thành công`);
        onHide()
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
      }
    } catch (error: any) {
      toast.warning(error?.response?.data?.message || "Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }
  console.log(dataVatTuEdit)
  console.log(initialValuesVatTu)
  return (
    <div>
      <Modal
        centered
        show={show}
        // onHide={onHide}
        size="xl"
        fullscreen
        className="page-full spaces h-calc-vh-50"
      >
        <ModelHeader onHide={onHide} title={`${initialValuesVatTu?.thongTinChung?.id ? 'Cập nhật' : 'Thêm mới'} ${nhomVatTu?.defauiltName}`} />
        <Modal.Body className="spaces p-0 mt-5 bg-white">
          <Formik<VatTu>
            enableReinitialize
            initialValues={initialValuesVatTu}
            validationSchema={generateValidationSchema(listJsonGenerate, nhomVatTu?.description || "thongTinChung")}
            onSubmit={handleFormSubmit}
          >
            <FormThemMoi listJsonGenerate={listJsonGenerate} isReload={show} onHide={onHide} />
          </Formik>
        </Modal.Body>

      </Modal>
    </div>
  );
};
export default DialogThemMoiVatTu;
